import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useTooltipControllerSharedState } from './useTooltipControllerSharedState';
import { useTooltipControllerOpen } from './useTooltipControllerOpen';
import { useTooltipControllerTouch } from './useTooltipControllerTouch';
export function useTooltipController(props) {
  var children = props.children;
  var childrenRef = React.useRef(null);
  var handleChildrenRef = useForkRef(children.ref, childrenRef);
  var state = useTooltipControllerSharedState();
  var _useTooltipController = useTooltipControllerOpen({
      props: props,
      state: state,
      childrenRef: childrenRef
    }),
    open = _useTooltipController.open,
    handleClose = _useTooltipController.handleClose,
    createHandleEnter = _useTooltipController.createHandleEnter,
    handleLeave = _useTooltipController.handleLeave;
  var handleEnterForward = createHandleEnter(true);
  var _useTooltipController2 = useTooltipControllerTouch({
      props: props,
      state: state,
      handleEnter: handleEnterForward,
      handleClose: handleClose
    }),
    handleTouchStart = _useTooltipController2.handleTouchStart,
    handleTouchEnd = _useTooltipController2.handleTouchEnd;
  var childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onMouseOver: handleEnterForward,
    onMouseLeave: handleLeave,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    ref: handleChildrenRef
  });
  return {
    open: open,
    childrenProps: childrenProps,
    tooltipProps: {
      open: open,
      anchorRef: childrenRef,
      onMouseLeave: handleLeave,
      onMouseEnter: createHandleEnter(false)
    }
  };
}